<template>
	<div
		class="Annotation"
		:class="{
			hidden,
			alternateHandles,
		}"
		:style="{
			top,
			left,
			bottom,
			right,
			color: color ? color : '#ff7f00'
		}"
	>
		<div
			v-if="showLabels || alternateHandles"
			class="Annotation-label"
			:data-annotation-handle="annotationIndex + '-label'"
			v-on:contextmenu.prevent.stop="$emit('annotation-selected', annotationIndex, $event)"
		>
			{{ annotationIndex + 1 }}: {{ label }}
		</div>
		<template v-if="enabledAnnotating">
			<div
				v-for="(edge, index) in handles"
				:key="index"
				:data-annotation-handle="[`${annotationIndex}-${edge}`]"
				:class="[`Annotation-handle Annotation-handle--${handles.length - index > 4 ? 'edge' : 'corner'} Annotation-handle--${edge}`]"
			></div>
			<div
				v-if="!alternateHandles"
				class="Annotation-handle Annotation-handle--middle"
				:data-annotation-handle="annotationIndex + '-middle'"
			>
				{{ annotationIndex + 1 }}
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'CloAnnotation',
	props: {
		top: {
			type: String,
		},
		left: {
			type: String,
		},
		bottom: {
			type: String,
		},
		right: {
			type: String,
		},
		scale: {
			type: Number,
			default: 1
		},
		color: {
			type: String,
		},
		hidden: {
			type: Boolean,
		},
		showLabels: {
			type: Boolean
		},
		enabledAnnotating: {
			type: Boolean,
		},
		alternateHandles: {
			type: Boolean,
		},
		edgeHandles: {
			type: Boolean
		},
		annotationIndex: {
			type: Number,
		},
		label: {
			type: String,
		},
	},
	computed: {
		handles() {
			return [
				...this.edgeHandles ? [
					'left', 
					'right', 
					'bottom', 
					'top', 
				] : [],
				'topLeft', 
				'topRight', 
				'bottomLeft', 
				'bottomRight'
			]
		}
	}
};
</script>

<style lang="scss">
.Annotation {
	border: calc(var(--scale) * 2px) solid;
	position: absolute;
	pointer-events: none;
	.Annotation-label {
		position: absolute;
		bottom: calc(100% + 2px);
		left: -2px;
		pointer-events: none;
		color: $color-text;
		padding: calc(var(--scale) * 1px) calc(var(--scale) * 3px);
		@include text(1);
		background-color: $color-overlay-white;
		border-top-left-radius: calc(var(--scale) * 3px);
		border-top-right-radius: calc(var(--scale) * 3px);
		border: calc(var(--scale) * 1px) solid $color-neutral-3;
		font-size: calc(var(--scale) * 10px);
		border-bottom: 0;
		white-space: nowrap;
		color: $color-text;
		z-index: 1;
	}
	.Annotation-handle {
		transform: scale(var(--scale));
		position: absolute;
		pointer-events: all;
		z-index: 1;
		&--left,
		&--right {
			transform: translateX(-50%);
			width: 10px;
			height: 100%;
			cursor: ew-resize;
		}
		&--right {
			left: 100%;
			&::after {
				left: 50%;
			}
		}
		&--top,
		&--bottom {
			transform: translateY(-50%);
			height: 10px;
			width: 100%;
			cursor: ns-resize;
		}
		&--bottom {
			top: 100%;
			&::after {
				top: 50%;
			}
		}
		&--topLeft {
			left: -7px;
			top: -7px;
			cursor: nwse-resize;
		}
		&--topRight {
			right: -7px;
			top: -7px;
			cursor: nesw-resize;
		}
		&--bottomLeft {
			left: -7px;
			bottom: -7px;
			cursor: nesw-resize;
		}
		&--bottomRight {
			right: -7px;
			bottom: -7px;
			cursor: nwse-resize;
		}
		&--middle {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%) scale(var(--scale));
			cursor: move;
			height: 14px;
			width: 14px;
			font-size: 10px;
			line-height: 1.2;
			text-align: center;
			font-weight: bold;
			color: $color-text;
			border: 1px solid $color-black;
			background-color: $color-white;
		}
		&--corner {
			border: 1px solid $color-black;
			background-color: $color-white;
			height: 12px;
			width: 12px;
		}
	}
	&.hidden,
	&.deleted {
		display: none;
	}
	&.alternateHandles {
		.Annotation-handle {
			border: 0;
			background-color: transparent;
			&--topLeft {
				&:after {
					content: '';
					position: absolute;
					height: 12px;
					width: 12px;
					top: 2px;
					left: 2px;
					border-left: 2px solid currentColor;
					border-top: 2px solid currentColor;
				}
			}
			&--topRight {
				&:after {
					content: '';
					position: absolute;
					height: 12px;
					width: 12px;
					top: 2px;
					right: 2px;
					border-right: 2px solid currentColor;
					border-top: 2px solid currentColor;
				}
			}
			&--bottomLeft {
				&:after {
					content: '';
					position: absolute;
					height: 12px;
					width: 12px;
					bottom: 2px;
					left: 2px;
					border-left: 2px solid currentColor;
					border-bottom: 2px solid currentColor;
				}
			}
			&--bottomRight {
				&:after {
					content: '';
					position: absolute;
					height: 12px;
					width: 12px;
					bottom: 2px;
					right: 2px;
					border-right: 2px solid currentColor;
					border-bottom: 2px solid currentColor;
				}
			}
		}
		.Annotation-label {
			pointer-events: all;
			cursor: move;
		}
	}
}
</style>
